import { MessageProxy } from "@intelligems/ig-embedded-preview/MessageProxy";
import { AppListenerMiddleware } from "@src/store";
import { getHighlights } from "@src/store/slices/experienceBuilder/common/selectors/getHighlights";

export const setupSendHighlightsListener = (
  middleware: AppListenerMiddleware,
  messageProxy: MessageProxy
) =>
  middleware.startListening({
    predicate: (_, curr, prev) => getHighlights(curr) !== getHighlights(prev),
    effect: (_, { getState }) => {
      messageProxy.send("ig-highlights", getHighlights(getState()));
    },
  });
